import api from './api'

export const authApi = {
  async login(credentials) {
    const response = await api.post('/auth/login', credentials)
    return response
  },

  async register(userData) {
    const response = await api.post('/auth/register', userData)
    return response
  },

  async getCurrentUser() {
    const response = await api.get('/auth/profile')
    return response
  },

  async refreshToken() {
    const refreshToken = localStorage.getItem('refresh_token')
    const response = await api.post('/auth/refresh', {}, {
      headers: {
        Authorization: `Bearer ${refreshToken}`
      }
    })
    return response
  },

  async logout() {
    const response = await api.post('/auth/logout')
    return response
  }
}